//
import PosSaleModel from '@/models/POS/PosSale'

/**
 * 
 */
export default class PosSaleService {

  /**
   * 
   */
  // toModify() {
  //   return this.payload({
  //     global_discount       : 'discount_or_percentage',
  //     global_discount_amount: 'discount_or_percentage',
  //     pos_sale_type         : 'discount_or_percentage',
  //     purchase_order        : 'discount_or_percentage',
  //   })
  // }

  /**
   * 
   */
  static model() {
    return PosSaleModel
  }
  
  /**
   * Modifica el numero de orden de compra del vale de venta.
   * 
   * @param   {PosSaleModel}  posSale                 - vale de venta 
   * @param   {string|number} pchPurchaseOrderNumber  - numero de orden
   * @returns Promesa con la petición asociada a la API
   */
  static modifyPurchaseOrder(posSale, pchPurchaseOrderNumber) {
    // let payload = PosSalePayload.from(posSale).toModifyPurchase(pchPurchaseOrderNumber)
    // let request = this.model().many('modify').attach(payload)
    // return request

    return this
      .model()
      .from({ id: 'modify' })
      .attach({
        customer_id           : posSale.sl_customer_id,
        flag_store_pickup     : posSale.flag_store_pickup,
        global_discount       : posSale.discount_or_charge_percentage,
        global_discount_amount: posSale.discount_or_charge_amount,
        // pos_origin_sale_id    : posSale.pos_origin_sale_id,
        pos_origin_sale_id    : 3, // Conserva la orden de despacho si llegase a tener
        pos_sale_type         : posSale.pos_sale_type_id,
        purchase_order        : pchPurchaseOrderNumber,
        sale_detail           : posSale.pos_detail_sales.map(item => ({
          product_id          : item.wh_product_id,
          quantity            : item.quantity,
          price               : isNaN(item.price) ? 0 : parseInt(item.price),
          discount            : item.discount_or_charge_percentage, // En %
          discount_unit_price : item.discount_or_charge_value, // En monto
          wh_warehouse_id     : item.wh_warehouse_id
        })),
        sale_to_modify_id     : posSale.id, // venta a modificar
        seller_user_code      : posSale.g_seller_user.auth_code,
        total                 : posSale.ticket_total, // Para validar los campos
      })
  }
}